import React, { useEffect, useState } from 'react'
import AliceCarousel from 'react-alice-carousel'
import { Product, useGetAllSocialProjectsQuery } from '../../generated/graphql'
import { MdChevronLeft, MdChevronRight } from 'react-icons/md'
import ProductCard from '../ProductCard/ProductCard'
import { SliderContainer } from '../../utils/AliceCarouselCustomSlider'
import { Container } from '../NewNewsSliders/styles'
import ALICE_CAROUSEL_DEFAULTS from '../../utils/AliceCarouselDefaults'

const SocialProjectsSlider: React.FC = () => {
    const { data, loading, error } = useGetAllSocialProjectsQuery({
        fetchPolicy: 'network-only',
        variables: {
            getAllProductInput: {
                type: '',
            },
        },
    })

    const [itens, setItens] = useState<any[]>()
    const responsive = {
        0: { items: 1 },
        320: { items: 2 },
        325: { items: 2 },
        425: { items: 2 },
        568: { items: 3 },
        768: { items: 4 },
        1024: { items: 6 },
    }

    useEffect(() => {
        if (data?.getAllSocialProjects) {
            setItens(
                data.getAllSocialProjects.filter(
                    (item) => item.active && item.stock && item.stock > 0
                )
            )
        }
    }, [data])

    const renderPrevButton = ({ isDisabled }: any): JSX.Element => {
        return (
            <span style={{ opacity: isDisabled ? '' : 1 }}>
                <MdChevronLeft color="black" size="3rem" />
            </span>
        )
    }

    const renderNextButton = ({ isDisabled }: any): JSX.Element => {
        return (
            <span style={{ opacity: isDisabled ? '' : 1 }}>
                <MdChevronRight color="black" size="3rem" />
            </span>
        )
    }

    if (itens?.length === 0 || loading) {
        return <></>
    }

    return (
        <SliderContainer>
            <Container>
                <div className="home-container">
                    <div className="product-cards-container">
                        <div className="container-title">
                            <h1>Projetos Sociais</h1>
                        </div>
                        <AliceCarousel
                            {...ALICE_CAROUSEL_DEFAULTS}
                            renderPrevButton={renderPrevButton}
                            renderNextButton={renderNextButton}
                            items={itens?.map((product: Product) => {
                                return (
                                    <ProductCard
                                        product={product}
                                        key={product?.id}
                                    />
                                )
                            })}
                        />
                    </div>
                </div>
            </Container>
        </SliderContainer>
    )
}

export default SocialProjectsSlider
